import { api } from "../api";

/* ======================================
   TYPES
====================================== */

export interface UsuarioUpdateProps {
  cpf?: string;
  name?: string;
  email?:string
  telefone?: string;
  imageUser?: string;
  datanascimento?: string;
}

/* ======================================
   BUSCAR USUÁRIO
====================================== */

export async function buscarUsuario() {
  const response = await api.get("/identity/users/me");

  const usuario = response.data;

  return {
    ...usuario,
    datanascimento: usuario.birthdate,
  };
}

/* ======================================
   ATUALIZAR USUÁRIO
====================================== */

export async function atualizarUsuario(data: UsuarioUpdateProps) {
  const payload = {
    ...data,
    ...(data.datanascimento !== undefined && {
      birthdate: data.datanascimento,
    }),
  };

  delete payload.datanascimento;

  const cleanData = Object.fromEntries(
    Object.entries(payload).filter(
      ([_, value]) => value !== undefined,
    ),
  );

  await api.patch("/identity/profile", cleanData);
}

/* ======================================
   UPLOAD FOTO USUÁRIO
====================================== */

export async function uploadImagemUsuario(
  file: File,
): Promise<string> {
  /* ======================================
     PEGA URL ASSINADA
  ====================================== */

  const extensao = file.name
    .split(".")
    .pop()
    ?.toLowerCase();

  if (
    !extensao ||
    !["jpg", "jpeg", "png", "webp"].includes(extensao)
  ) {
    throw new Error(
      "Formato inválido. Use jpg, jpeg, png ou webp.",
    );
  }

  const response = await api.post(
    "/identity/users/me/avatar/upload-url",
    {
      fileExtension: extensao,
    },
  );

  const { uploadUrl, fileUrl, key } = response.data;

  /* ======================================
     UPLOAD S3
  ====================================== */

  await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  /* ======================================
     SALVA AVATAR
  ====================================== */

  await api.patch("/identity/users/me/avatar", {
    key,
  });

  return fileUrl;
}

/* ======================================
   REMOVER FOTO USUÁRIO
====================================== */

export async function removerImagemUsuario() {
  await api.patch("/identity/users/me/avatar", {
    avatarKey: "",
  });
}